import { render, staticRenderFns } from "./CoverLetterEditing.vue?vue&type=template&id=b627228c&scoped=true&"
import script from "./CoverLetterEditing.vue?vue&type=script&lang=js&"
export * from "./CoverLetterEditing.vue?vue&type=script&lang=js&"
import style0 from "./CoverLetterEditing.vue?vue&type=style&index=0&id=b627228c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b627228c",
  null
  
)

export default component.exports